import React, { Fragment } from 'react';

const CompanyNotifications = () => {
  return (
    <Fragment>
      <div className="notification-box">
        <div className="notifications-title blue">
          <i className="fas fa-bell fa-lg blue mx-5"></i>
          Notifications
          <span className="clear">
            <i className="far fa-times-circle fa-sm mr-2 blue"></i>
            clear all
          </span>
        </div>
        <div className="all-notifications" id="blue-scroll">
          <div className="notification">
            <div className="single-notification">
              <div className="notif-avi-container">
                <div className="notif-avi"></div>
              </div>
              <div className="notification-text blue">
                <div className="notification-type">
                  <i className="fas fa-user-friends mx-5 blue"></i>
                  Certification Request
                  <div className="remove-notification">
                    <i className="fas fa-times blue"></i>
                  </div>
                </div>
                <div className="notification-text-title">
                  User Name Sent you a certification request
                  <span className="blue cursor mx-5 bold">Accept</span>
                  or<span className="blue cursor mx-5 bold">Decline</span>?
                </div>
                <div className="notification-date">
                  <i className="far fa-clock mx-5 blue"></i>
                  Date
                </div>
              </div>
            </div>
          </div>
          <div className="notification">
            <div className="single-notification">
              <div className="notif-avi-container">
                <div className="notif-avi"></div>
              </div>
              <div className="notification-text blue">
                <div className="notification-type">
                  <i className="fas fa-check mx-5 blue"></i>
                  New Follower
                  <div className="remove-notification">
                    <i className="fas fa-times blue"></i>
                  </div>
                </div>
                <div className="notification-text-title">
                  User's Name just followed you!
                </div>
                <div className="notification-date">
                  <i className="far fa-clock mx-5 blue"></i>
                  Date
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyNotifications;
